import React, { useState, memo, useRef, useEffect } from "react";
import Formsy from "formsy-react";
import { NavLink, withRouter, Link } from "react-router-dom";
import { MdArrowBack, MdModeEdit } from "react-icons/md";
import { TextInput } from "../../../Shared/Forms";
import { Row, Col, UncontrolledAlert, Card, CardHeader, CardBody, Button } from "reactstrap";
import "./imageFrame.css";
import { sendMealPlanServices } from "./service/publishMealPlan.service";
import TextEditor from "../../../Shared/Forms/TextEditor";
import {  UserEditMealPlan, ManageAllMealPlansPage } from "../../../../_constants/RouteVariables";

const ViewSpecificMealPLan = memo((props) => {
    const mealPlanFormRef = useRef("viewMealPlanForm");

    const [name, setName] = useState(null);
    const [description, setDescription] = useState(null);
    const [calories, setCalories] = useState(null);
    const [generalImageUrl, setGeneralImageUrl] = useState(null);
    const [days, setDays] = useState(null);
    const [mealId, setMealId] = useState(null);
    const [roaster, setRoaster] = useState(null);
    const [status, setStatus] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [reviewerRemarks, setReviewerRemarks] = useState(null);
    const [fullData, setFullData] = useState(null);

    //image error handling..
    const [error, setError] = useState(null);
    const dailyMealRoaster = async (id) => {
        try {
            let response = await sendMealPlanServices.getDailyMealRoaster(id);
            if (response) {
                setRoaster(response.data);
                setIsEdit(true);
            }
        } catch (e) {
            setError(e);
        }
    };

    const stopEdit = () => {
        setIsEdit(false);
    };
    const mapMealType = (mealType) => {
        switch (mealType) {
            case 1:
                return "Others";
            case 2:
                return "BreakFast";
            case 3:
                return "Lunch";
            case 4:
                return "Dinner";
            case 5:
                return "Snack";
        }
    };

    useEffect(() => {
        if (props && props.location) {
            const { mealData } = props.location.state;

            setStatus(mealData.status);
            setReviewerRemarks(mealData.reviewerRemarks);
            setMealId(mealData.id);
            setName(mealData.name);
            setDescription(mealData.description);
            setCalories(mealData.calories);
            setGeneralImageUrl(mealData.imageUrl);
            setDays(mealData.durationDays);
            setFullData(mealData);
        }
    }, []);

    useEffect(() => {
        if (mealId) {
            dailyMealRoaster(mealId);
        }
    }, [mealId]);

    return (
        <React.Fragment>
            <NavLink to={ManageAllMealPlansPage}>
                <Button type="button" color="primary" className="mb-2">
                    <MdArrowBack />
                    <span>Back</span>
                </Button>
            </NavLink>
            <Formsy ref={mealPlanFormRef}>
                {error && !error.errors ? <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert> : null}
                {error && error.errors && error.error.length ? (
                    <UncontrolledAlert color="danger">
                        {error.errors.map((error, index) => (
                            <p key={index}>{error.message}</p>
                        ))}
                    </UncontrolledAlert>
                ) : null}
                <Card>
                    <CardHeader>View Meal Plan</CardHeader>
                    <CardBody>
                        <Row>
                            <Col sm="5">
                                <TextInput name="name" required title="Name" disabled={true} value={name ? name : null} />
                                <TextInput name="description" required title="Description" disabled={true} value={description ? description : null} />
                                <TextInput name="calories" required title="Total Calories (Kcals) " disabled={true} value={calories ? calories : null} />
                            </Col>
                            <Col sm="7">
                                <div style={{ width: "74%" }}>
                                    <TextInput name="durationDays" required title="Duration(Day(s))" disabled={true} value={days ? days : null} />
                                </div>

                                <div style={{ paddingTop: "1rem" }} className="frame">
                                    <img src={`${generalImageUrl}`} alt="" height="100%" width="100%"></img>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12" md={{ size: 6, offset: status === "DECLINED" ? 2 : 3 }}>
                                <Card>
                                    <CardHeader className="mb-2">Meal Roster</CardHeader>
                                    {roaster &&
                                        roaster.map((e, index) => (
                                            <CardBody className="mealRoasterFrame mb-2" id={index}>
                                                <span>DAY {e.day}</span>

                                                {e &&
                                                    e.plan.map((i, index) => (
                                                        <Card id={index}>
                                                            <CardHeader>Meal type : {mapMealType(i.mealType)}</CardHeader>
                                                            <CardBody>
                                                                <p>Food item(s):</p>
                                                                {i &&
                                                                    i.meal.map((k, v) => (
                                                                        <Card className="mb-2" id={v} key={v}>
                                                                            <CardBody key={v}>
                                                                                <Row className="measurementSpaces mb-2">
                                                                                    <Col key={v}>
                                                                                        {" "}
                                                                                        <small>{"Food Item"}</small>
                                                                                    </Col>
                                                                                    <Col key={v}>
                                                                                        <small>{"Metric Unit"}</small>
                                                                                    </Col>
                                                                                    <Col key={v}>
                                                                                        <small>{"Quantity"}</small>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row className="measurementSpaces" key={v}>
                                                                                    <Col key={v}>
                                                                                        <small>{k && k.name}</small>
                                                                                    </Col>
                                                                                    <Col key={v}>
                                                                                        <small>{k && k.measure}</small>
                                                                                    </Col>
                                                                                    <Col key={v}>
                                                                                        <small>{k && k.quantity}</small>
                                                                                    </Col>
                                                                                </Row>
                                                                            </CardBody>
                                                                        </Card>
                                                                    ))}
                                                                <Formsy>
                                                                    <TextInput name="recipes" title="Recipe" disabled={true} value={i && i.recipe ? i.recipe.title : null} />
                                                                    <TextEditor name="body" value={null} isViewOnly={true} isEdit={isEdit} stopEdit={stopEdit} postBody={i.recipe.content} toolbarHidden={true} stripPastedStyles={true} mealType={true} recipe={`Recipes`} />
                                                                </Formsy>
                                                            </CardBody>
                                                        </Card>
                                                    ))}
                                            </CardBody>
                                        ))}
                                </Card>
                            </Col>
                            {status === "DECLINED" ? (
                                <aside>
                                    <Card style={{ minWidth: "20rem" }}>
                                        <CardHeader>Redraft Comment</CardHeader>
                                        <CardBody>
                                            <p>{reviewerRemarks}</p>
                                            <br />
                                            <Row>
                                                <Col sm="12 offset-3">
                                                    <Link
                                                        to={{
                                                            pathname: UserEditMealPlan,
                                                            state: { mealData: fullData },
                                                        }}
                                                        style={{ textDecoration: "none" }}
                                                    >
                                                        <Button type="button" color="primary" size="lg">
                                                            <MdModeEdit />
                                                            <span>Edit Meal Plan</span>
                                                        </Button>
                                                    </Link>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </aside>
                            ) : null}
                        </Row>
                    </CardBody>
                </Card>
            </Formsy>
        </React.Fragment>
    );
});

export default withRouter(ViewSpecificMealPLan);
